import { LayoutAuth } from "@/components/layout-auth";
import { Login } from "@/components/auth-flow/login/login";
import { AsidePanel } from "@/components/aside/aside-panel";
import { LaunchDarklyProvider } from "@/contexts/launchdarkly-context";
import { MotionConfig } from "motion/react";

export default function LoginPage() {
  return (
    <MotionConfig reducedMotion="user">
      <LaunchDarklyProvider>
        <LayoutAuth
          primary={<Login />}
          secondary={<AsidePanel showTestimonial={true} />}
        />
      </LaunchDarklyProvider>
    </MotionConfig>
  );
}
